module.exports = function(it){
  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
  return it;
};


//////////////////
// WEBPACK FOOTER
// /data/app/rdc-next/~/core-js/modules/_a-function.js
// module id = 56
// module chunks = 48 49 50 51